import { Component } from '@angular/core';

@Component({
  selector: 'app-unsupported-resolution-screen',
  template: `
    <div style="width: 100%; height: 100%" class="horizontal layout center middle">
      <mat-icon style="font-size: 200px; width: 200px; height: 200px; color: #f3f3f3;">mobile_off</mat-icon>
    </div>
  `,
  styles: []
})
export class UnsupportedResolutionScreenComponent {

  constructor() { }

}
